export const reportingStates = {
  ALL: null,
  RECAP_ONLY: 'recap-only',
  RATINGS_ONLY: 'ratings-only',
  NONE: 'none'
}
